<template>
  <footer class="main-footer">
    <div class="container">
      <section class="know-more">
        <div class="brand">
          <div class="logo">
            <img src="@/assets/logo-white.png" alt="">
          </div>
        </div>
        <div class="related">
          <div class="links">
            <h4 class="title">
              Explore
            </h4>
            <ul class="links-list">
              <li class="link-item"
                  v-bind:key="title"
                  v-for="(url, title) in footerLinks">
                <a v-bind:href="url"
                  v-html="title"
                  class="link">
                </a>
              </li>
            </ul>
          </div>
          <div class="contact">
            <h4 class="title">
              Contact
            </h4>
            <p class="contact-info">
              invest@keepcannabislocal.com<br><br>
              2727 N Third Street, Suite 201<br>
              Phoenix, AZ 85004<br>
            </p>
          </div>
        </div>
        <div class="phone-number">
          <div class="phone-container">
            <p class="uptitle">
              Call Anytime
            </p>
            <p class="phone">
              800-403-1140
            </p>
          </div>
        </div>
      </section>
      <section class="legal-messages">
        <p class="copyright">
          KeepCannabisLocal.com © 2022
        </p>
        <div class="message">
          <h4 class="title">
            Legal Disclaimer
          </h4>
          <p class="legal-disclaimer">
            The offering will be made only by means of an offering circular. An offering statement regarding this offering has been filed with the SEC. The SEC has qualified that offering statement which only means that Item 9 Labs Corp. may make sales of the securities described by that offering statement. It does not mean that the SEC has approved, passed upon the merits or passed upon the accuracy or completeness of the information in the offering statement. The securities offered by the company are highly speculative. Investing in shares of common stock of Item 9 Labs Corp involves significant risks. The investment is suitable only for persons who can afford to lose their entire investment. Furthermore, investors must understand that such investment could be illiquid for an indefinite period of time. No public market currently exists for the securities, and if a public market develops following the offering, it may not continue. You may obtain a copy of the Form 1-A offering circular that is part of said offering statement here. You should read the offering circular before making any investment.
          </p>
        </div>
        <div class="message">
          <h4 class="title">
            Forward-Looking Statements Disclaimer
          </h4>
          <p class="legal-disclaimer">
            The offering materials and this letter may contain forward-looking statements and information relating to, among other things, the company, its business plan and strategy, and its industry. These forward-looking statements are based on the beliefs of, assumptions made by, and information currently available to Item 9 Labs Corp management. When used in the offering materials, the words “estimate,” “project,” “believe,” “anticipate,” “intend,” “expect” and similar expressions are intended to identify forward-looking statements, which constitute forward looking statements. These statements reflect management’s current views with respect to future events and are subject to risks and uncertainties that could cause Item 9 Labs Corp actual
          </p>
        </div>
      </section>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/footer.scss';
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      footerLinks: {
        'FAQS': '#faqs',
        'Invest Now': 'https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view',
        'Call': 'tel:+1-800-403-1140',
        'Email': 'mailto:invest@keepcannabislocal.com',
      },
    };
  },
};
</script>